
import { useNavigate } from 'react-router-dom';

/**
 * Primary header component used throughout the app.
 * Accepts optional plan/rewards props and displays user information.
 */
const Header = ({
  userPlan,
  dailyRewards = 0,
  totalRewards = 0,
}) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear authentication‑related data
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('user');
    localStorage.removeItem('userPlan');
    localStorage.removeItem('claimedRewards');

    // Redirect to login page
    navigate('/auth/login');
  };

  // Safely retrieve the user name – guard against malformed JSON
  let userName = 'User';
  const rawUser = localStorage.getItem('user');
  if (rawUser) {
    try {
      const parsed = JSON.parse(rawUser);
      if (parsed?.name) userName = parsed.name;
    } catch (e) {
      console.warn('Failed to parse user from localStorage', e);
    }
  }

  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-100 z-50">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg flex items-center justify-center">
              <i className="ri-store-line text-white text-lg" />
            </div>
            <h1
              className="text-lg font-bold text-gray-900"
              style={{ fontFamily: '"Pacifico", serif' }}
            >
              SweetCommerce
            </h1>
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;

